

<h1 style="color: purple;">yproducts works! </h1>
<div class="flex md:flex-row flex-col justify-between items-center">
  <div class="flex md:w-auto w-full lg:my-10 my-5 justify-between items-center">
    <app-field

      class="ms-2 w-full md:w-[350px]"
      placeholder="ابحث عن منتج .."
    >
      <div class="text-lg absolute rtl:left-3 ltr:right-3 top-1/2 -translate-y-1/2">
        <span nz-icon nzType="search" nzTheme="outline"></span>
      </div>
    </app-field>
  </div>
  <app-button size="md" class="w-full md:w-auto mb-3 md:mb-0" routerLink="./add-edit-holiday-home">
    <div class="items-center flex">
      <span nz-icon nzType="plus-circle" class="me-2 text-lg" nzTheme="fill"></span>
      <span class="text-base font-bold">Add Product </span>
    </div>
  </app-button>

</div>



<ng-container  *ngIf="products$ ;else noProducts">

  @for (model of products$; track $index) {

      <app-product-card [prodModel]="model"  >



        <p> {{$index}}</p>
      </app-product-card>

      }
</ng-container>

<ng-template #noProducts>
  <h1>
      no products yet ...
  </h1>
</ng-template>
